export default "__VITE_ASSET__DdWy2XlF__"